import { apiFetch } from "./api";

export function getCtoBundle(beid) {
  return apiFetch(`/provision/${encodeURIComponent(beid)}/cto-bundle`);
}

export function getDeviceIdentities() {
  return apiFetch("/provision/device-identities", { cache: "no-store" });
}

export function getGraceWindow(beid) {
  return apiFetch(`/provision/${encodeURIComponent(beid)}/grace-window`);
}
